<template>

    <div class="account-tab">
        <p class="customer"
           v-html="$t('customerGroup.description', {customerGroup:customerFn.getCustomerGroup(customer.customerGroup)})"></p>
        <SfTabs>
            <!-- Personal data update -->
            <SfTab :title="$t('myProfile.profileUpdate.tab.title')">
                <p class="message">
                    {{ $t('myProfile.profileUpdate.tab.message') }}
                </p>
                <profilUpdateForm></profilUpdateForm>
            </SfTab>

            <!-- Password reset -->
            <SfTab v-if="customer.customerGroup!=='Empowerment'"
                   :title="$t('myProfile.passwordUpdate.tab.title')">
                <!-- <p class="message">
                   {{ $t('myProfile.passwordUpdate.tab.message') }}
                 </p>-->
                <passwordChangeForm></passwordChangeForm>
            </SfTab>
        </SfTabs>
    </div>
</template>

<script>

import {SfTabs} from '@storefront-ui/vue';
import profilUpdateForm from '@/components/MyAccount/ProfileUpdateForm';
import passwordChangeForm from '@/components/MyAccount/PasswordChangeForm.vue';
import {Customer} from "@/models/customer";

export default {
    name: 'PersonalDetails',

    components: {
        SfTabs,
        profilUpdateForm,
        passwordChangeForm,
    },
    data() {

        return {
            customerFn: Customer
        }
    },
    computed: {
        customer: {
            get() {
                return this.$store.getters.getProfile
            }
        },
    }
};
</script>

<style lang='scss' scoped>
.message,
.notice {
  font-family: var(--font-family--primary);
  line-height: 1.6;
}

.message {
  margin: 0 0 var(--spacer-xl) 0;
  font-size: var(--font-size--base);

  &__label {
    font-weight: 400;
  }
}

.notice {
  margin: var(--spacer-lg) 0 0 0;
  font-size: var(--font-size--sm);
}

.account-tab {
  margin-top: var(--spacer-base)
}

::v-deep {
  .sf-tabs {
    &__tab {
    }

    &__title {
      // text-transform: uppercase;
    }

    &__chevron {
      margin: 0 0 0 auto;
    }
  }
}
</style>
